import { Component, inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FollowedAuthor } from 'src/app/models/followed-author';
import { SearchModel } from 'src/app/models/search-model';
import { LocaleService } from 'src/app/services/locale.service';
import { UserService } from 'src/app/services/user.service';
import { BookClub } from '../../models/bookclub';
import { ConfigService } from '../../services/config.service';
import { SwiperOptions } from 'swiper/types/swiper-options';
import { swiperDefaultConfig } from '../../_shared/components/swiper/swiper.configuration';
import { ToastService } from 'src/app/_core/services/toast.service';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-slider-authors',
  templateUrl: './slider-authors.component.html',
  styleUrls: ['../slider/slider.component.scss', './slider-authors.component.scss'],
})
export class SliderAuthorsComponent {
  readonly swiperConfig: SwiperOptions = {
    breakpoints: {
      0: {
        slidesOffsetAfter: 8,
        slidesOffsetBefore: 8,
      },
    },
    slidesPerView: 'auto',
    navigation: {
      enabled: !this.configService.notDesktopDevice(),
    }
  }

  readonly swiperPlaceholderConfig: SwiperOptions = {
    enabled: false,
    slidesOffsetAfter: 20,
    slidesOffsetBefore: 20,
    spaceBetween: 36,
    breakpoints: {
      ...swiperDefaultConfig.breakpoints,
      768: {
        ...swiperDefaultConfig.breakpoints['768'],
        slidesOffsetAfter: 28,
        slidesOffsetBefore: 28,
      },
      1200: {
        ...swiperDefaultConfig.breakpoints['1200'],
        slidesOffsetAfter: 48,
        slidesOffsetBefore: 48,
      },
    },
    navigation: {
      enabled: false,
    }
  };

  private readonly toastService = inject(ToastService);
  private readonly apiService = inject(ApiService);

  readonly showUnfollowedAuthorsDialog = signal<boolean>(false);

  @Input()
  authors: FollowedAuthor[];

  @Input()
  title: string;

  @Input()
  placeholder = false;

  @Input()
  preview = false;

  visible = false;
  fadeAnimation: string;
  authorNames: string[] = [];
  textDirection: string;

  constructor(
    private configService: ConfigService,
    private userService: UserService,
    private router: Router,
    private localeService: LocaleService,
  ) { }

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();
  }

  setVisible() {
    this.visible = true;
    if (this.placeholder) {
      this.fadeAnimation = 'visible';
    } else {
      this.fadeAnimation = 'hidden';
    }
  }

  addAuthors() {
    this.router.navigate(['/search', 'authors']);
  }

  onSelected(item: BookClub) {
    const bookClubUrl = this.configService.get().bookClubUrl;
    window.open(`${bookClubUrl}#!/clubs/${item.id}`, '_blank', 'noopener');
  }

  viewAll() {
    this.router.navigate(['/authors']);
  }

  exploreCatalog() {
    const model = new SearchModel();
    model.explore = true;

    this.router.navigate(['/results'], {
      queryParams: model.toRequest(),
    });
  }

  unfollowAllAuthors() {
    this.showUnfollowedAuthorsDialog.set(false);
    this.apiService.unfollowAllAuthors(this.userService.getUserId()).subscribe(() => {
      this.userService.followedAuthors = [];
      this.toastService.showToast('lists.allAuthorsUnfollowed');
    });
  }
}
